import { defineMessages } from 'react-intl';

export default defineMessages({
  logoutSuccess: {
    id: 'snackbar.logoutSuccess',
    defaultMessage: 'You’ve been successfully logged out',
  },
  error: {
    id: 'snackbar.error',
    defaultMessage: 'Error',
  },
  timeoutExperience: {
    id: 'snackbar.timeoutExperience',
    defaultMessage: 'This session is going to expire soon. If you’re still there, tap anywhere to resume.',
  },
  timeoutBooking: {
    id: 'snackbar.timeoutBooking',
    defaultMessage: 'Are you still there? Tap here to continue or',
  },
  endSession: {
    id: 'snackbar.endSession',
    defaultMessage: 'end this session now.',
  },
  resetPasswordEmailSent: {
    id: 'snackbar.resetPasswordEmailSent',
    defaultMessage: 'Please check your email for further instructions.',
  },
  yourProfileDataUpdated: {
    id: 'snackbar.yourProfileDataUpdated',
    defaultMessage: 'Your profile has been successfully updated.',
  },
  cancelBookingSuccess: {
    id: 'snackbar.cancelBookingSuccess',
    defaultMessage: 'Experience has been successfully cancelled.',
  },
});
